<template>
  <vx-card class="mt-base" :title="activityTitle">
    <p class="mb-5">
      <strong>You will need:</strong> A tape measure, chalk, a straight edge (or a ruler and a
      pencil if doing it on paper)
    </p>
    <centered-image-wrapper
      :image="require('@/assets/images/experiences/construction/activity_41.png')"
      classes="xl:w-1/2 lg:w-2/3 w-full"
      alt="Line drawing of the 3-4-5 method: a right-angled triangle set out on the ground beside a wall with a window. The side along the wall measures 4 m, the short side at right angles to it measures 3 m, and the long diagonal side, marked with a tape measure, measures 5 m."
    />
    <p class="mb-5">
      Most buildings and other structures are built using straight lines. This means that the most
      common shapes we find on construction sites are squares and rectangles - where all the corners
      are 90° angles or right angles.
    </p>
    <p class="mb-5">
      It’s important when setting out and checking work to be able to form or check the accuracy of
      a right angle simply and quickly. The 3-4-5 Method enables you to create an accurate right
      angle on-site at any time and with minimal equipment.
    </p>
    <p class="mb-5">
      Watch the video below to learn how to use the 3-4-5 Method to set out a right angle on site.
    </p>
    <p class="mb-5">
      Although the video shows a bricklayer setting out using the 3-4-5 Method, this method is not
      just for bricklayers. Everyone from carpenters to construction managers will find a use for
      it.
    </p>

    <div class="vx-row my-5 flex items-center justify-center">
      <div class="vx-col xl:w-1/2 lg:w-2/3 w-full my-5">
        <responsive-iframe-youtube :src="videos[1]" :posterimg="videoTrigger1" />
      </div>
    </div>

    <p class="mb-5">
      The method is very straightforward, but be sure to watch the short video above enough times to
      make sure you know how to do it. When you’re ready, it’s time to practise!
    </p>
    <p class="mb-5">
      You can use a tape measure, chalk, and a straightedge to mark out a right angle on the
      concrete outside, or, if you prefer, you can simply use a pencil and ruler to try out the
      method on a piece of paper.
    </p>
    <p class="mb-5">
      Remember, too, even though this method is called the 3-4-5 method, you can scale up and down
      as long as you keep everything in proportion.
    </p>
    <p class="mb-5">
      Practise this method until you can perform the technique quickly and accurately.
    </p>

    <div class="vx-row my-5">
      <div class="vx-col w-full">
        <vs-radio
          vs-name="data-question1"
          v-model="data['question1']"
          class="checkbox_answer multiline"
          :vs-value="1"
          >I was able to complete this task</vs-radio
        >
      </div>
      <div class="vx-col w-full">
        <vs-radio
          vs-name="data-question1"
          v-model="data['question1']"
          class="checkbox_answer multiline"
          :vs-value="0"
          >I struggled to complete this task</vs-radio
        >
      </div>
    </div>
    <label>Comments:</label>
    <textarea-block v-model="data.question2" :editable="isEditable" />

    <save-buttons :is-editable="isEditable" @save="save" />
  </vx-card>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';

export default {
  data() {
    return {
      videoTrigger1: require('@/assets/images/experiences/construction/345_method_splash.jpg'),
      videos: {
        1: 'https://www.youtube.com/embed/-_sIq1h-Gc4',
      },
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
};
</script>
